import { configureStore } from "@reduxjs/toolkit";
import imageRecognition from "./slices/imageRecognition";
import testSlice from "./slices/test";

const store = configureStore({
  reducer: {
    imageRecognition: imageRecognition.reducer,
    test: testSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['imageRecognition/loadModels/fulfilled'],
        // Ignore these paths in the state
        ignoredPaths: ['imageRecognition.models', 'imageRecognition.imagesStack'],
       
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
